import styled, { css } from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint } from 'react-components'
import { CarouselProvider, Slider } from 'pure-react-carousel'

export const SliderContainer = styled.div(
    ({ theme }) => css`
        position: ${theme.style.position.relative};
        max-width: fit-content;
        margin-top: ${theme.spacing.xSmall};
    `,
)

export const StyledCarouselProvider = styled(CarouselProvider)<{ margin?: string; center?: boolean }>(
    ({ theme, margin = '0', center }) => css`
        width: 100%;
        margin: ${margin};

        li {
            list-style: none;
        }

        ${center &&
        css`
            > .carousel__slider {
                padding: 0 ${theme.spacing.medium};

                @media only screen and (min-width: ${tabletBreakpoint.min}px) {
                    padding: 0 ${theme.spacing.large};
                }

                @media only screen and (min-width: ${desktopBreakpoint.min}px) {
                    padding: 0;
                }
            }
        `}
    `,
)

export const StyledSlider = styled(Slider)<{ $transitionTime?: number }>(
    ({ theme, $transitionTime }) => css`
        padding: 0;
        overflow: hidden;

        ul {
            transition: transform ${$transitionTime ? `${$transitionTime}s` : '0.5s'};
            transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
            will-change: transform;
        }

        .carousel__slider-tray {
            display: flex;

            @media only screen and (min-width: ${desktopBreakpoint.min}px) {
                gap: ${theme.spacing.medium};
            }
        }
    `,
)
